import * as React from "react";

function HpSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={41.655}
      height={41.654}
      {...props}
    >
      <path
        d="M20.827 41.655c-.207 0-.413 0-.619-.01l4.256-11.7h5.858a2.866 2.866 0 002.507-1.756l4.618-12.684a2.634 2.634 0 00-2.647-3.773h-8.122L19.863 30.47l-3.871 10.62A20.831 20.831 0 0115.2.771l-3.984 10.964-6.632 18.212H9l5.639-15.478h3.317l-5.641 15.479h4.412l5.257-14.441a2.634 2.634 0 00-2.641-3.775h-3.712l4.26-11.71Q20.357 0 20.827 0a20.827 20.827 0 110 41.655zm12.6-27.2h-3.314L25.468 27.2h3.317z"
        fill="#4987ce"
      />
    </svg>
  );
}

export default HpSvg;
